const SvgBigChevronLeft = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 14 32">
    <path d="M0 15.882 12.706 0l.49.392L.804 15.882l12.392 15.49-.49.392z" />
  </svg>;
export default SvgBigChevronLeft;